export default __webpack_public_path__ + "static/media/twitterIcon.86efdbad.svg";